import store from "../store";
import { isProduction } from "../utilities";
import { DisconnectedCallInfo } from "./disconnectedCallInfo";

export class DisconnectedCallService {
    public static isDisconnected(): boolean {
        return store.state.configuration.disconnected;
    }

    public static async isSuppressed(url: string): Promise<boolean> {
        if (!DisconnectedCallService.isDisconnected()) {
            return false;
        }

        const match = await this.getDisconnectedCallInfo(url);
        return match != null;
    }

    public static async getDisconnectedCallInfo(url: string): Promise<null | DisconnectedCallInfo> {
        if (!DisconnectedCallService.isDisconnected()) {
            return null;
        }

        let allDisconnectedCallInfo: Array<DisconnectedCallInfo> = [];

        if (!isProduction()) {
            await import('./disconnectedCalls').then((module) => {
                allDisconnectedCallInfo = module.DisconnectedCalls.all;
            });
        }

        for (const disconnectedCallInfo of allDisconnectedCallInfo) {
            if (disconnectedCallInfo.url == url) {
                return disconnectedCallInfo;
            }
        }

        return null;
    }
}
